import Arena from '@/assets/graphical-elements/arena.svg'
import {cn} from '@/lib/utils'
import {type IconProps} from '../types'

export const ArenaIcon = ({className}: IconProps) => <Arena className={cn('fill-current', className)} />
